<ng-container *transloco="let t">
    <div class="offcanvas-header p-5 border border-bottom-2">
        <h4 class="offcanvas-title" id="offcanvas-basic-title" transloco="label_quick_search"></h4>
        <button type="button" class="btn-close btn btn-light-secondary rounded" aria-label="Close"
            (click)="activeOffcanvas.dismiss()"></button>
    </div>
    <div class="offcanvas-body card-scroll p-3 responsive-scroll">
        <app-free-search></app-free-search>
    </div>
</ng-container>